import React from "react";

import SingleSessionPricesTable from "components/PageDashboard/SingleSessionPricesSection/SingleSessionPricesTable";
import { useSingleSessionPrices } from "hooks/useSingleSessionPrices";
import { saveSingleSessionPrices } from "api/saveSingleSessionPrices";
import { SingleSessionPrice } from "types-and-validators/SingleSessionPrice";
import PricesSection from "components/PageDashboard/PricesSection";
import { SessionType } from "types-and-validators/SessionType";

type RowData = {
	item: SingleSessionPrice;
	sessionType: SessionType;
};

const SingleSessionPricesSection: React.FunctionComponent = () => {
	return (
		<PricesSection<RowData>
			usePrices={useSingleSessionPrices}
			savePrices={saveSingleSessionPrices}
			table={({
				onEdit,
				pricesWithSessionTypes,
				sessionTypesLoading,
				pricesLoading,
				sessionTypesWaiting,
				pricesWaiting,
				sessionTypesError,
				pricesError,
				waitModalTitle,
				waitModalIsShowing
			}) => {
				return (
					<SingleSessionPricesTable
						onEdit={onEdit}
						singleSessionPricesWithSessionTypes={
							pricesWithSessionTypes ? pricesWithSessionTypes : []
						}
						isLoading={sessionTypesLoading || pricesLoading}
						isWaiting={sessionTypesWaiting || pricesWaiting}
						isError={sessionTypesError || pricesError}
						waitModalTitle={waitModalTitle}
						waitModalIsShowing={waitModalIsShowing}
					/>
				);
			}}
		/>
	);
};

export default SingleSessionPricesSection;
